module.exports = __webpack_public_path__ + "Lato-Bold.ttf?eb9532033c2adf99b1314611b5e9cd0e";